import React from 'react';

import Header from '../../layout/Header.jsx';
import ListCertificates from '../../lists/ListCertificates.jsx';

const PageCertificates = () => (
  <div>
    <Header>Certificate Download</Header>
    <ListCertificates />
  </div>
);

export default PageCertificates;
